/**
 * Helpers gerais da tela de SQLs de Integração.
 */

/**
 * A tela aceita SQL e PHP. Base única: a coluna `sql_erp.tipo` — qualquer
 * valor diferente de "sql" (ex.: "PHP") é tratado como PHP. Case-insensitive.
 *
 * @param {string|null|undefined} tipo valor persistido de `sql_erp.tipo`
 * @returns {boolean}
 */
export function ehPhp(tipo) {
  return String(tipo || 'sql').toLowerCase() !== 'sql';
}

/**
 * Extrai os aliases (`AS nome`) de um SQL, em MAIÚSCULO.
 * Usado pelo autocomplete do SqlEditor e pelos chips do CamposAccordion
 * (a mesma regex era duplicada nos dois componentes).
 *
 * @param {string|null|undefined} sql
 * @returns {Set<string>} aliases em maiúsculo
 */
export function extractAliases(sql) {
  const aliases = new Set();
  const regex = /\bAS\s+["'`]?([A-Za-z_][\w$]*)["'`]?/gi;
  let m;
  while ((m = regex.exec(sql || '')) !== null) {
    aliases.add(m[1].toUpperCase());
  }
  return aliases;
}
